(function () {

    const STORAGE_KEY = "wishlist";

    function read() {

        try {

            return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

        } catch {

            return [];

        }

    }

    function write(items) {

        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

        document.dispatchEvent(new CustomEvent("wishlist:updated", {
            detail: items
        }));

    }

    window.Wishlist = {

        getAll() {

            return read();

        },

        count() {

            return read().length;

        },

        exists(id) {

            return read().some(item => item.id == id);

        },

        add(product) {

            const items = read();

            if (!items.some(item => item.id == product.id)) {

                items.push(product);

                write(items);

            }

        },

        remove(id) {

            write(read().filter(item => item.id != id));

        },

        toggle(product) {

            if (this.exists(product.id)) {

                this.remove(product.id);

                return false;

            }

            this.add(product);

            return true;

        },

        clear() {

            write([]);

        }

    };

})();